<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M19.883 40a6.883 6.883 0 0 0-6.156 3.8A6.766 6.766 0 0 0 13 46.851a.641.641 0 0 1-.578.649.625.625 0 0 1-.672-.625 8.2 8.2 0 0 1 .414-2.57.312.312 0 0 0-.364-.405A5 5 0 0 0 8 48.75a5.081 5.081 0 0 0 5.07 5h6.805A6.875 6.875 0 1 0 19.883 40z" style="fill:#517dfb" transform="translate(-7.375 -36.875)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-tutorial01',
});
</script>
